import { IFAQCategory } from '../../../_models/cms/IFAQ';
import { IPaged } from '../../../_models/common/IPaged';
import { FAQCategoryService } from './../../../shared/services/faq-category.service';
import { FAQService } from './../../../shared/services/faq.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DashboardComponent implements OnInit, OnDestroy {

  is_navbar_ghost: boolean | null;
  sub: Subscription;
  faqCategories: IFAQCategory[];
  faqCategory: IFAQCategory;

  private readonly PAGE_SIZE = 10;

  queryResult: IPaged = {
    pageNumber: 0,
    items: [],
    totalRows: 0,
    pageSize: this.PAGE_SIZE
  };

  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'Id',
    sortDir: 'Descending',
    faqCategoryId: null
  };

  subscription: Subscription;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private service: FAQService,
    private faqCategoryService: FAQCategoryService) {
  }

  ngOnInit() {
    this.bindDropDown();

      this.subscription = combineLatest(this.route.params, this.route.queryParams,
        (params, qparams) => ({ params, qparams })).subscribe(ap => {
          this.query.page = isNaN(ap.qparams.page) ? 1 : ap.qparams.page;
          this.query.sort = ap.qparams.sort ? ap.qparams.sort : this.query.sort;
          this.query.sortDir = ap.qparams.sortDir ? ap.qparams.sortDir : this.query.sortDir;
          this.query.faqCategoryId = ap.qparams.faqCategoryId ? ap.qparams.faqCategoryId : '';
          this.populateFAQs();
        });
  }

  private populateFAQs() {
    this.service.getAll(this.query)
      .subscribe((response: IPaged) => {
        if (response) {
          this.queryResult = response;
          if (this.query.faqCategoryId) {
            this.faqCategory = this.faqCategories.find(x => x.id == this.query.faqCategoryId);
          }
        }
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  bindDropDown() {
    this.faqCategoryService.getAllFAQCategories().subscribe((response: IFAQCategory[]) => {
      if (response) {
        this.faqCategories = response;
      }
    });
  }

}
